import React, { useState, useEffect } from "react";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { redirect, useNavigate, useParams } from "react-router-dom";
import { encryptText } from "../../utils/cipherText";
import FinsireLoginLogo from "../../images/FinsireLoginLogo";
import { MdOutlineVisibilityOff } from "react-icons/md";
import { MdOutlineVisibility } from "react-icons/md";
import { CiLock } from "react-icons/ci";
import { HiXMark } from "react-icons/hi2";
import { IoCheckmarkOutline } from "react-icons/io5";
import { useLocation } from "react-router-dom";

import ConfirmPasswordImage from "../../images/ConfirmPasswordImage";

const ConfirmPassword = () => {
  const location = useLocation();
  const { validated } = location.state || {};
  const navigate = useNavigate();
  const { id } = useParams();
  const [captchaFilled, setCaptchaFilled] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);
  const [error, setError] = useState("");
  const [nullPassword, setNullPassword] = useState("");
  const [nullConfirmPassword, setNullConfirmPassword] = useState("");
  const [passwordDone, setPasswordDone] = useState(false);

  const [containsLength, setContainsLength] = useState(false);
  const [containsNumber, setContainsNumber] = useState(false);
  const [containsSpecial, setContainsSpecial] = useState(false);
  const [containsCaps, setContainsCap] = useState(false);
  const [validPassword, setValidPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaFilled) {
      setError("Please fill captcha!");
      return;
    }

    if (!password) {
      setNullPassword(true);
      setError("Password cannot be Empty!");
      return;
    }
    if (!confirmPassword) {
      setNullConfirmPassword(true);
      setError("Password cannot be Empty!");
      return;
    }
    if (password !== confirmPassword) {
      setError("Password and confirm password does not match");
      return;
    }
    if (
      password === confirmPassword &&
      password &&
      confirmPassword &&
      captchaFilled &&
      validPassword
    ) {
      const options = {
        headers: { Authorization: id },
        url: `${process.env.REACT_APP_URL}/lender/set_password`,
        method: "PUT",
        data: {
          password: password === confirmPassword && password,
        },
      };
      const res = await axios(options);
      if (res.status === 200 && res.data.status) {
        navigate("/", { replace: true });
      }
    }
  };

  useEffect(() => {
    function isStrongPassword(password) {
      if (
        capsRegex.test(password) &&
        numRegex.test(password) &&
        specialCharRegex.test(password) &&
        lengthRegx.test(password)
      ) {
        return true;
      } else return false;
    }
    //Test password against pattern
    const capsRegex = /^(?=.*[A-Z]).+$/;
    const numRegex = /\d/;
    const lengthRegx = /^.{8,}$/;
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;

    if (capsRegex.test(password)) {
      setContainsCap(true);
    } else setContainsCap(false);

    if (numRegex.test(password)) setContainsNumber(true);
    else setContainsNumber(false);

    if (lengthRegx.test(password)) setContainsLength(true);
    else setContainsLength(false);

    if (specialCharRegex.test(password)) setContainsSpecial(true);
    else setContainsSpecial(false);

    if (isStrongPassword(password)) setValidPassword(true);
    else setValidPassword(false);
    if (
      password &&
      confirmPassword &&
      captchaFilled &&
      isStrongPassword(password)
    ) {
      setPasswordDone(true);
    } else {
      setPasswordDone(false);
    }
  }, [password, confirmPassword, captchaFilled]);

  const passwordLabels = [
    {
      text: "include at least one uppercase character",
      condition: containsCaps,
    },
    {
      text: "include at least one number",
      condition: containsNumber,
    },
    {
      text: "include at least one special character",
      condition: containsSpecial,
    },
    {
      text: "include minimum of 8 characters",
      condition: containsLength,
    },
  ];
  useEffect(() => {
    if (!validated) {
      navigate("/");
    }
  }, []);
  return (
    <div className="login-main-wrap flex bg-white font-[Inter,sans-serif]">
      <div className="login-form-wrap max-lg:w-[100vw] w-[50vw] h-[100vh] flex items-center justify-center">
        <form
          className="login-form max-lg:w-[80vw] max-lg:p-3 max-md:w-[90vw] min-h-[60vh] w-[30vw] text-[13px] flex-col"
          onSubmit={handleSubmit}
        >
          {/* <FinsireLoginLogo /> */}
          <h1 className="w-full flex items-center justify-center mb-12 text-3xl font-medium">
            Confirm password
          </h1>
          <div className="form-input flex flex-col w-full">
            {/* dsasd */}
            <label className="m-0 p-0 bottom-0 font-semibold">Password</label>
            <div
              style={{ outlineColor: "#d1d5db" }}
              className={`password-input shadow border-style  rounded  w-full flex items-center h-10  mb-6 ml-[0.2rem] mt-[0.29rem] font-medium outline-1 outline `}
            >
              <input
                name="password"
                type={passwordShow ? "text" : "password"}
                id="password"
                className={`font-normal  outline-none pt-0 pb-0 pl-4 pr-4 w-[90%] m-0`}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError("");
                }}
                onCopy={(e) => {
                  e.preventDefault();
                }}
                value={password}
                placeholder="Password"
                required
              />
              {!passwordShow && (
                <div
                  className="input-inside-div cursor-pointer "
                  onClick={() => setPasswordShow(true)}
                >
                  <MdOutlineVisibilityOff
                    style={{ fontSize: "23px", color: "#d1d5db" }}
                  />
                </div>
              )}
              {passwordShow && (
                <div
                  className="input-inside-div"
                  onClick={() => setPasswordShow(false)}
                >
                  {/* <VisibilityIcon style={{ fontSize: "25px" }} /> */}
                  <MdOutlineVisibility
                    style={{ fontSize: "23px", color: "#d1d5db" }}
                  />
                </div>
              )}
            </div>
            {/* ------------------ */}
            <label className="m-0 p-0 bottom-0 font-semibold">
              Confirm Password
            </label>
            <div
              style={{ outlineColor: "#d1d5db" }}
              className={`password-input shadow border-style rounded  w-full flex items-center h-10  mb-6 ml-[0.2rem] mt-[0.29rem] font-medium outline-1 outline `}
            >
              <input
                className={`font-normal outline-none pt-0 pb-0 pl-4 pr-4 w-[90%] m-0`}
                name="password"
                type={confirmPasswordShow ? "text" : "password"}
                id="password"
                onCopy={(e) => {
                  e.preventDefault();
                }}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  setError("");
                }}
                onPaste={(e) => {
                  e.preventDefault();
                }}
                value={confirmPassword}
                placeholder="Confirm password"
                required
              />
              {!confirmPasswordShow && (
                <div
                  className="input-inside-div cursor-pointer "
                  onClick={() => setConfirmPasswordShow(true)}
                >
                  {/* <VisibilityOffIcon style={{ fontSize: "25px" }} /> */}
                  <MdOutlineVisibilityOff
                    style={{ fontSize: "23px", color: "#d1d5db" }}
                  />
                </div>
              )}
              {confirmPasswordShow && (
                <div
                  className="input-inside-div"
                  onClick={() => setConfirmPasswordShow(false)}
                >
                  {/* <VisibilityIcon style={{ fontSize: "25px" }} /> */}
                  <MdOutlineVisibility
                    style={{ fontSize: "23px", color: "#d1d5db" }}
                  />
                </div>
              )}
            </div>

            <div
              className={` justify-center shadow items-center  w-full  text-xs mb-4 rounded outline-1 outline font-light  ml-[0.2rem] pb-2 pt-2 ${
                validPassword ? "text-green-500" : "text-[#D1D5DB]"
              }  `}
              style={{ outlineColor: "" }}
            >
              <p
                className={` text-[14px] text-left ml-2 text-black font-normal  flex items-center`}
              >
                <span className=" inline-block text-2xl   mr-2 ">
                  <CiLock style={{ fontSize: "20px" }} />
                </span>
                <p> Your password needs to:</p>
              </p>
              {passwordLabels?.map((p) => (
                <>
                  <p
                    className={`ml-10 mt-1 mb-1 flex items-center space-x-1 text-[#999]`}
                  >
                    {" "}
                    <span
                      className={`inline-block text-base p-0 ${
                        p.condition ? "text-green-500" : "text-red-500"
                      } `}
                    >
                      {p.condition ? <IoCheckmarkOutline /> : <HiXMark />}
                    </span>
                    {"   "}
                    <p>{p.text}</p>
                  </p>
                </>
              ))}
            </div>
            {error && (
              // <div className=" flex justify-center outline-red-300 items-center content-center w-full text-xs mb-4 rounded outline-1 outline font-normal  ml-[0.2rem] ">
              //   <p className="text-[#999] text-[12px]  text-center pt-2 pb-2">
              //     {error}
              //   </p>
              //   <p></p>
              // </div>
              <div
                class="bg-red-100  border-red-400 text-red-700 px-4 py-3 rounded relative mb-3 size w-full ml-[0.2rem]"
                role="alert"
              >
                <strong class="font-bold">Error! </strong>
                <span class="block sm:inline">{error}</span>
              </div>
            )}
          </div>
          <div
            className="recaptcha-div mb-4"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_URL_CAPTCHA_KEY}
              onChange={() => setCaptchaFilled((prev) => !prev)}
              size="normal"
              className=" p-2"
            />
          </div>

          <button
            style={
              passwordDone ? {} : { background: "gray", cursor: "default" }
            }
            disabled={!passwordDone}
            className={`login-btn w-full pt-[10px] pb-[10px] pl-0 pr-0 text-base font-[550] rounded-md border-none text-[#00394d] cursor-pointer bg-gradient-to-r from-[#39bc00] to-[#a0ff77] ${
              !captchaFilled ? "bg-gray-600" : ""
            }`}
            type="submit"
          >
            Submit
          </button>
        </form>
      </div>
      <div className="login-side-image max-lg:hidden  w-[50vw] h-[100vh] flex items-center justify-center bg-custom">
        <ConfirmPasswordImage />
      </div>
    </div>
  );
};

export default ConfirmPassword;
